import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import routes from './routes';
import './styles/reset.css';
import './styles/index.css';
import '@/assets/iconfont/iconfont.css';
import WebSocketProvider from '@/providers/WebSocketProvider.jsx';
import Drawer from '@/components/drawer/Drawer';
// import SubscribeOpen from '@/components/subscribeopen/SubscribeOpen';
import '@radix-ui/themes/styles.css';
import { Theme } from '@radix-ui/themes';
import { DrawerProvider } from '@/context/DrawerContext';

import '@/utils/i18n.ts';
import { Toaster } from 'react-hot-toast';
import { initSentry } from '@/utils/Sentry/sentryConfig';
import { IntercomProvider, useIntercom } from 'react-use-intercom';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
const APP_ID = 'ckafr53n'; // 将你的 Intercom App ID 填入
const changeFavicon = (url) => {
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = url;
  document.head.appendChild(link);
};
export function InitApp() {
  useEffect(() => {
    if (new URLSearchParams(window.location.search).get('tfrom')) {
      sessionStorage.setItem('tfrom', new URLSearchParams(window.location.search).get('tfrom'));
    }
    changeFavicon(
      window.matchMedia('(prefers-color-scheme: dark)').matches ? '/favicon2.ico' : '/favicon.ico',
    );
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleThemeChange = (event) => {
      if (event.matches) {
        // 深色模式
        changeFavicon('/favicon2.ico');
      } else {
        // 浅色模式
        changeFavicon('/favicon.ico');
      }
    };
    mediaQuery.addEventListener('change', handleThemeChange);
    return () => {
      mediaQuery.removeEventListener('change', handleThemeChange);
    };
  }, []);
  return null;
}
initSentry();
export function IntercomManager() {
  const { boot } = useIntercom(); // 只需要使用 boot

  useEffect(() => {
    const initializeIntercom = async () => {
      const generateUserId = async () => {
        const fpPromise = FingerprintJS.load();

        // 获取设备指纹
        return fpPromise.then((fp) => fp.get());
      };

      const visitorId = await generateUserId();
      console.log(visitorId.visitorId, ' generateUserId()');

      try {
        boot({
          userId: visitorId.visitorId,
          // name: 'starxing',
          email: '',
        });
        sessionStorage.setItem('intercomUpdate', Date.now());
      } catch (error) {
        console.log(error, 'errorerror');
      }
    };
    setTimeout(initializeIntercom, 1000);
  }, [boot]);

  return null;
}

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <IntercomProvider appId={APP_ID}>
      <WebSocketProvider>
        <Theme>
          <DrawerProvider>
            <InitApp />
            <IntercomManager />
            <RouterProvider router={routes} />
            <Drawer />
          </DrawerProvider>
        </Theme>
      </WebSocketProvider>
      <Toaster />
    </IntercomProvider>
  </Provider>,
);

if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) {
        console.error('Cannot remove a child from a different parent', child, this);
      }
      return child;
    }
    return originalRemoveChild.apply(this, [child]);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.error(
          'Cannot insert before a reference node from a different parent',
          referenceNode,
          this,
        );
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, [newNode, referenceNode]);
  };
}
